import Action from '../../Action';
// import './styles/ModalDeleteUSer.css'
import { useState,useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
// import './Maintenance-styles/ModalAddHost.css'
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
const ModalHostList =({source,server,languaje,handleShowPopup,mode,hosts,elementsList,SetElementList,setDataWorkFlow,dataWorkFlow,brand,closHostsListModal})=>{
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  // const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [response,setResponse]=useState([])
  var dataList = searchTerm === "" ? response : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [loadingM,setLoadingM]=useState(false);
  const [exportLoading,setExportLoading]=useState(false)

  const handleSelectAll = () => {
      if (allSelected) {
        // Si ya está todo seleccionado, deselecciona todo
        setPoolRows([]);
      } else {
        setPoolRows(hosts.map(item => item.hostid))
      }
      setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
    };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value);setPageActual(1);
  };
  /************************************************* */
  /************************************************* */
  /************************************************* */
  /*******************seleccionar host ************* */
  /************************************************* */
  /************************************************* */
  /************************************************* */
  const Exportar=(file_type)=>{

    let method='POST'
const body={
  "file_type": file_type,
  "brand_ids": poolRows
}
    setExportLoading(true)
      const fetchDataPost = async () => {
        
     try {
       // console.log(localStorage.getItem('access_token'))
       const response = await fetch(server.url+'/api/v1/cassia/monitoring_devices/status_report/custom-tabs/'+source+'_excel/'+brand.groupid, {
         method: 'GET',  
         headers: {
            "Accept": "application/json",
           // 'Content-Type': 'application/json',
           'Content-Type': 'application/json',
             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
           },
         // body: JSON.stringify(body),
       });
       if (response.ok) {
        // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
     const blob = await response.blob();
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;

     // Dependiendo del tipo de archivo, nombramos el archivo a descargar
     if (file_type === 'json') {
       link.download = 'Marcas.json';
     } else if (file_type === 'csv') {
       link.download = 'Marcas.csv';
     } else if (file_type === 'excel') {
       link.download = source+'_'+brand.group_name+'.xlsx'; // Archivo de Excel
     }

     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     setAllSelected(false)
     setPoolRows([])
     setExportLoading(false);
     handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)

       } else {
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
           
        }
      };
  
      fetchDataPost();
      
}
  const search_host_list_by_source=()=>{
   
   
    setLoadingM(true)
      const fetchDataPost = async () => {
       
     try {
       // let urlSource=(source=='byGroupID')?'host_groups/hosts_list/'+brand.groupid:'hosts/byTemplateID/'+brand.templateid
       // console.log('/api/v1/cassia/'+urlSource)
       const response = await fetch(server.url+'/api/v1/cassia/cis_v2/groups/hosts/'+brand.id, {
         method: 'GET',  
         headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
         // body:JSON.stringify(host_list)
       });
       if (response.ok) {
         const data1 = await response.json();
         setLoadingM(false)
         setResponse(data1.data)
         // buscar_cis()
         // handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])),'', true)
         // closDeleteUserModal()

         // console.log(data1);
       } else {
         const data1 = await response.json();
       handleShowPopup('Error!!!',data1.detail,capitalizeFirstLetter(lang[languaje]['reportError']), false)
       // setError(error)
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
          // Manejo de errores
          // const data1 = await response.json();
          handleShowPopup('Error!!!','',capitalizeFirstLetter(lang[languaje]['reportError']), false)
          // setError(error)
          console.error(error);
        }
      };
  
      fetchDataPost();
      
}
  useEffect(()=>{
    search_host_list_by_source()
  },[])

  return(
      <>
      <div className="modal-GS-content">
      <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                  Miembros del Grupo: &nbsp; {brand.name}
                  </div>
              </div>
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',display:'block'}}>
                  <div className='half-content-card-modal-gs' style={{width:'100%',height:'90%'}}>
                  <>
 <div className='head-cis'>
  <div className='title-cis'>
              <Search
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                  dataObject={response}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  languaje={languaje}
                />
        <div className={"cont-result-registers"+mode} style={{width:'25%',bottom:'0px'}}>
       
                <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p> 
        </div>
       
             
           
              </div>
              
          </div>
          <div className='cont-cis'>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode}>
    <>
                    <div style={{fontSize:'var(--font-size-xSmall',width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',color:'var(--txt-color)'}}>
                     {brand.group_name}
                    </div>
                    {(exportLoading)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
                    <>
                    <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
        {/* <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/csv_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('csv')}
                  style={{opacity:(contRowsSelected==0)? '0.3':'1',
                    pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'CSV  '}
                      </div>
                    </div> */}
                   {/* <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/json_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('json')}
                  style={{opacity:(contRowsSelected==0)? '0.3':'1',
                    pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'JSON'}
                      </div>
                    </div> */}
                    <div className="half-excels-buttons-portafolio">
                    
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/xsl_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('excel')}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                      {'EXCEL'}
                      </div>
                    </div>
               </div>
               </>
                    }
                    </>
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
           
          <div className="cont-table-portafolio">
    <div className={"head-table-portafolio"+mode}>
    <div className="compact-head-table-portafolio">
    {/* <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
               <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}} onChange={()=>console.log("all")}  onClick={()=>handleSelectAll()} ></input>
              </div></div> */}
      {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
      <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{' ID'}</div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}} >{capitalizeFirstLetter(lang[languaje]['nombre'])} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}} >{'IP'} </div>
     <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}} >{'Zona'} </div>
      </div>
    </div>
    <div className="body-table-portafolio">
     
    <>
    <div className="cont-row-user-list">
      {(
        loadingM?<div className="cont-load-user-list">
        <LoadSimple></LoadSimple>
      </div>:
        dataList
          .slice((dataList.length<limitList?0:startLimit), parseInt(pageActual) * parseInt(limitList))
          .map((elemento, indice) => (
            <div
              className={" row-table-portafolio"+mode }
              key={indice}
             
            >
               
              {/* <div className="field-body-table-mantenimiento field-small">
                {elemento.hostid}
              </div> */}
              <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                {elemento.folio}
              </div>
              <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}}>
                {elemento.name}
              </div>
              <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}}>
                {elemento.ip}
              </div>
              <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}}>
                {elemento.location}
              </div>
              
             
              
              
             
            </div>
          ))
      )}
      { (response.length == 0 ) ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
      ) : (
        ""
      )}
    </div>
    
  </>
    </div>
  </div>
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode}>
        <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
          
          {/* <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                    </p> 
                
          </div> */}
        </div>  
        <div className="cont-display-paginador" style={{width:'60%'}}>
                  <Paginador  pages={pages}
                              pageActual={pageActual}
                              setPageActual={setPageActual}
                              mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador" style={{width:'50%'}}>
          <div className={"cont-half-display-paginador"+mode}>
                    
          <div>
    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
      <option value={10}>10</option>
      <option value={50} >50</option>
      <option value={100}>100</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>

    
  </div>
          </div>
          <div className={"cont-half-display-paginador"+mode} >
          <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                          &nbsp;
                          {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length > parseInt(pageActual ) * parseInt(limitList)
                        ? parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                    </p>
                    {/* {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']} */}
          </div>
        </div>  
                  
      </div>
      </div>
    </div>
    
  </>
              
          </div>
 </>
    
                  </div>
                  <div className='contentButtomsWorkflow'>
                  <div className="form-GS-box"> 
                  <div className="user-box-GS" style={{height:'100%'}}>
                                      {
                                          (false)?<LoadSimple></LoadSimple>
                                          :
                                          <>
                                          {/* <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>{cancelItem()}}/> */}
                                          <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['aceptar'])}  action={closHostsListModal}/>
                                          </>
                                          // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                  }
                                      
                                  </div>
                                  </div>
                  </div>
                  {/* <div className='half-content-card-modal-gs'>
                  <>
              <div className='head-cis'>
              <div className="cont-buttons-panel" style={{width:'50%'}}>
                
                <Action
                disabled={false}
                origen="Azul"
                titulo={""+capitalizeFirstLetter(lang[languaje]['Aceptar'])}
                action={closeAddHostModal}
              />
                
                  
                
               
              </div>
              
              </div>
          <div className='cont-cis'>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode} style={{background:'var(--third-color)',color:'var(--white-color)'}}>
              <div className='title-host-added'>{capitalizeFirstLetter(lang[languaje]['hostSelected'])}</div>
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
           
          <div className="cont-table-portafolio">
    
    <div className="body-table-portafolio">
     
    <>
    <div className="cont-row-user-list">
      
      {(
        hostSelected
          .map((elemento, indice) => (
              <div className='content-row-host-selected' key={indice}>
              <div className='row-host-selected'>
                  <div className='text-host-selected'>
                  {elemento.host}
                  </div>
                  <div className='delete-host-selected' onClick={(()=>rowSelected(elemento))}>
                                  X
                  </div>
              </div>              
          </div>
          ))
      )}
      { (dataList.length == 0 ) ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
      ) : (
        ""
      )}
    </div>
    
  </>
    </div>
  </div>
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode} style={{justifyContent:'center'}}>
        <div className="cont-display-paginador" style={{position: 'absolute',justifyContent: 'center',width:'50%'}}>
          
          <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {"("+hostSelected.length+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados'])}
                    </p> 
                
          </div>
        </div>  
        
         
                  
      </div>
      </div>
    </div>
    
  </>
              
          </div>
 </>
                  </div> */}
              </div>
          </div>
          </div>
      </>
  )
}

export default ModalHostList